<div class="notifications-viewport" [class.notifications-fixed]="variant === 'fixed'">
  @if (current; as notification) {
    <div
      class="card shadow-sm w-border rounded-3 mb-2 notifications-card"
      animate.enter="notification-enter"
      animate.leave="notification-leave"
      (click)="open()"
      [attr.aria-label]="notification.important ? ('HOMEMYLATESTNOTIFICATIONIMPORTANT' | translate) : null"
    >
      <div class="card-body notification-card-body">
        <div class="d-flex flex-column">
          <div class="notification-header">
            <div class="notification-avatar">
              <app-avatar
                [image]="notification.image?.path ?? ''"
                [name]="notification.title ?? ''"
                [subTitle]="notification.body ?? ''"
                [date]="createDate(notification.created_at)"
                [type]="'large'">
              </app-avatar>
            </div>

            <div class="notification-content">
              <div class="notification-headline">
                <app-content
                  [fontSize]="'fs-small'"
                  [fontColor]="'text-primary'"
                  [fontDecoration]="'fw-bold'"
                  [class]="'me-2 text-wrap truncate-text-one-line d-block'">
                  {{ notification.title }}
                </app-content>

                <app-content
                  [fontSize]="'fs-verysmall'"
                  [fontColor]="'text-muted'"
                  [class]="'d-block'"
                  [fontDecoration]="'fst-italic'">
                  {{ 'POSTEDAT' | translate }} {{ notification.created_at | date : 'medium' }}
                </app-content>
              </div>

              <div class="notification-body">
                <app-content
                  [fontSize]="'fs-small'"
                  [fontColor]="'text-muted'"
                  [class]="'truncate-text-two-lines'"
                  [type]="'richtext'"
                  [innerHTML]="notification.body ?? ''">
                </app-content>
              </div>

              <div class="notification-actions">
                <div class="notification-actions-main">
                  @if (notification.channel) {
                    <app-pill
                      [type]="'small'"
                      [rounded]="true"
                      [bgColor]="'bg-primary'"
                      [fontColor]="'text-white'">
                      {{ notification.channel.toUpperCase() | translate }}
                    </app-pill>
                  }
                </div>
              </div>
            </div>

            <div class="notification-rail">
              @if(notification.read === false && notification.important === true){
                <div class="notif-bell-static notif-bell--active">
                  <span class="notif-bell-container">
                    <app-icon-badge
                      [style]="'notification'"
                      [icon]="'notifications'"
                      [fontColor]="'text-danger'">
                    </app-icon-badge>
                  </span>
                </div>
              }

              @if (notification.channel !== 'chat') {
                <div class="notification-actions-menu">
                  <div class="dropdown">
                    <button
                      #actionsMenuTrigger
                      (click)="stopPrevent($event)"
                      type="button"
                      class="btn btn-link p-0 text-muted notification-menu-button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                      <app-icon-badge [style]="'notification'" [icon]="'more_horiz'"></app-icon-badge>
                    </button>

                    <ul class="dropdown-menu dropdown-menu-end">
                      @if(notification.read){
                        <li><app-link (click)="setUnRead($event, actionsMenuTrigger)" [title]="('BELLMARKASUNREAD' | translate)" [style]="'dropdown'">{{ ('BELLMARKASUNREAD' | translate) }}</app-link></li>
                      } @else {
                        <li><app-link (click)="setRead($event, actionsMenuTrigger)" [title]="('BELLMARKASREAD' | translate)" [style]="'dropdown'">{{ ('BELLMARKASREAD' | translate) }}</app-link></li>
                      }
                    </ul>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
